export const SESSION_DURATION_MS = 24 * 60 * 60 * 1000;
export const STAY_SIGNED_IN_DURATION_MS = 7 * SESSION_DURATION_MS;

export const clearStoredSession = () => {
  try {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('sessionExpiresAt');
  } catch {}
};

export const loadStoredSession = () => {
  try {
    const user = JSON.parse(localStorage.getItem('currentUser') || 'null');
    const expiresAt = Number(localStorage.getItem('sessionExpiresAt'));
    if (typeof user?.sessionId !== 'string' || !user.sessionId || user.sessionId !== localStorage.getItem('sessionId') || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
      clearStoredSession();
      return null;
    }
    return { user, expiresAt };
  } catch {
    clearStoredSession();
    return null;
  }
};

export const saveStoredSession = (user, expiresAt) => {
  try {
    localStorage.setItem('currentUser', JSON.stringify(user));
    localStorage.setItem('sessionId', user.sessionId);
    localStorage.setItem('sessionExpiresAt', String(expiresAt));
  } catch {
    clearStoredSession();
  }
};